<div class="layout-column custom-panel full-width full-height padding-10 gap-5">
  <!-- Header -->
  <div class="layout-column gap-5">
    <div class="layout-column">
      <div class="layout-row justify-content-between align-items-center">
        <div class="layout-row gap-5 align-items-center">
          <bringoz-icon iconName="BOX" class="gray-100"></bringoz-icon>
          <span class="flex font-weight-600 gray-100 br-body-1">{{'Split Packages Job' | translate:{jobId: serviceId} }}</span>
        </div>
        <bringoz-button type="tertiary"
                        (click)="close()"
                        size="sm">
          <bringoz-icon iconName="close"></bringoz-icon>
        </bringoz-button>
      </div>
    </div>
    <div class="header-bottom-border"></div>
  </div>

    <!-- Content -->
    <div class="flex layout-column package-content ">
      <ng-container *ngIf="packages?.length > 0; else noPackages">
        <div class="layout-column" *ngFor="let pkg of packages; trackBy: trackByPackageId; let i = index; let last = last">
          <div class="flex layout-column">
            <div class="package-row layout-row align-items-center gap-5"
                 [ngClass]="{ 'anchor': lastSelectedPackage.id === pkg.package.id && isShiftPressed }">

              <input type="checkbox"
                     [checked]="pkg.selected"
                     (change)="onPackageSelect(pkg, i)">

              <div *ngIf="pkg.package.barcode" class="layout-row layout-align-start center gap-5">
                <span class="text-ellipsis" [ngbTooltip]="pkg.package.barcode">{{ pkg.package.barcode }}</span>
                <span>|</span>
              </div>

              <div class="layout-row justify-content-around gap-5">
                <span>{{ pkg.package.weight | bringozWeight:true:'':true:2 }} </span>
                <span>|</span>
              </div>

              <div class="layout-row justify-content-around gap-5">
                <span>{{ pkg.package.pallets ?? 0 }}</span>
                <span translate>Pallets</span>
                <span>|</span>
              </div>

              <div class="layout-row justify-content-around gap-5">
                <span>{{ (pkg.package.volume ? pkg.package.volume : pkg.package.dimensions.cube) | bringozVolume:true }}</span>
                <span>|</span>
              </div>

              <span class="original-count">{{'Original-short' | translate}}: {{ pkg.originalCount }}</span>

              <span flex></span>

              <div class="flex layout-row justify-content-between">
                <span class="flex"></span>
                <input type="number"
                       [class.invalidInput]="isPackageInvalid(pkg)"
                       [ngModel]="pkg.selected ? pkg.package.count : 0"
                       (ngModelChange)="onCountChange($event, pkg, i)"
                       [disabled]="!pkg.selected || sitePackageItemsMap[pkg.package.size]?.splitSettings?.splitType !== 'BY_COUNT'"
                       min="1"
                       #packageInput
                       (keyup.enter)="packageInput.blur()">
              </div>
            </div>

            <hr *ngIf="!last">
          </div>
        </div>
      </ng-container>
      <ng-template #noPackages>
        <div class="flex layout-column align-items-center justify-content-center">
          <span translate>No Packages</span>
          <bringoz-icon iconName="package-outline" classSize="xxl"></bringoz-icon>
        </div>
      </ng-template>
    </div>

    <div class="layout-row padding-10-5">
      <span class="flex"></span>

      <!--Weight-->
      <bringoz-icon iconName="weight" class="bringoz-icon margin-left-10"></bringoz-icon>
      <div class="layout-row justify-content-around gap-5">
        <span>{{ selectedTotals.weight | bringozWeight:true:'':true:2 }} </span>
      </div>

      <!--Pallets-->
      <bringoz-icon iconName="pallets" class="bringoz-icon margin-left-10"></bringoz-icon>
      <div class="layout-row justify-content-around gap-5">
        <span>{{ selectedTotals.pallets ?? 0 | number: '1.0-2' }}</span>
        <span translate>Pallets</span>
      </div>

      <!--Volume-->
      <bringoz-icon iconName="volume" class="bringoz-icon margin-left-10"></bringoz-icon>
      <div class="layout-row justify-content-around gap-5">
        <span>{{ selectedTotals.volume | bringozVolume:true }}</span>
      </div>

      <!--Packages-->
      <bringoz-icon iconName="package" class="bringoz-icon margin-left-10"></bringoz-icon>
      <div class="layout-row justify-content-around gap-5">
        <span>{{ selectedPackages | servicePackagesCount }}</span>
        <span translate>Packages</span>
      </div>
    </div>

    <!-- Footer -->
    <div class="layout-column gap-5">
      <div class="footer-border-top"></div>
      <div class="layout-row justify-content-between">
        <bringoz-button size="sm" type="tertiary"
                        (click)="close()">
          <span translate>Cancel</span>
        </bringoz-button>
        <div class="layout-row gap-5">
          <bringoz-button size="sm" theme="secondary" type="outline"
                          [isDisabled]="!canSplit()"
                          (click)="onSplitAndAssignToRoute()">
            <span translate>Split & Add To Route</span>
          </bringoz-button>
          <bringoz-button size="sm" theme="secondary" type="outline"
                          [isDisabled]="!canSplit()"
                          (click)="onSplitAndAssignToResource()">
            <span translate>Split & Add To Resource</span>
          </bringoz-button>
          <bringoz-button size="sm" theme="secondary"
                          [isDisabled]="!canSplit()"
                          (click)="split()">
            <span translate>Split</span>
          </bringoz-button>
        </div>
      </div>
    </div>
</div>
